<button
    clButton
    [type]="type()"
    [severity]="severity() ?? 'primary'"
    [variant]="variant() ?? 'filled'"
    [clSize]="size() ?? 'normal'"
    [iconOnly]="iconOnly()"
    [class.icon-only]="iconOnly()"
    [disabled]="disabled()"
    [fluid]="fluid()"
    [attr.aria-label]="ariaLabel()"
>
    <ng-content />
</button>
